// InsertMediaPlugin.ts
// Custom CKEditor 5 toolbar button — mở modal "Thêm ảnh / video" của React.
// Nút nằm trong toolbar nên sticky theo toolbar khi cuộn nội dung.
// Giao tiếp với React qua CustomEvent (giống ImageAlbumPlugin).

import { ButtonView, Plugin } from "ckeditor5"

export const CK_OPEN_MEDIA_EVENT = "ck-open-media-modal"

const CAMERA_ICON = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.2 3 6.3 4.5H3.5A1.5 1.5 0 0 0 2 6v9a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 18 15V6a1.5 1.5 0 0 0-1.5-1.5h-2.8L12.8 3H7.2Zm2.8 4.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/></svg>`

export class InsertMediaPlugin extends Plugin {
  static get pluginName() {
    return "InsertMediaPlugin" as const
  }

  init() {
    const editor = this.editor

    editor.ui.componentFactory.add("insertMedia", (locale) => {
      const view = new ButtonView(locale)

      view.set({
        label: "Thêm ảnh / video",
        tooltip: true,
        withText: true,
        icon: CAMERA_ICON,
      })

      view.on("execute", () => {
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent(CK_OPEN_MEDIA_EVENT))
        }
      })

      return view
    })
  }
}
